import { render, staticRenderFns } from "./HomeSections.vue?vue&type=template&id=87608e5a"
import script from "./HomeSections.vue?vue&type=script&lang=js"
export * from "./HomeSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports